import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Levantamento Estoque Escola',
  path: '/merenda/merlevantamentoestoqueescola',
  name: 'merlevantamentoestoqueescola',
  component: () => import('@/views/merenda/merlevantamentoestoqueescola/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.LEVANTAMENTODEESTOQUEESCOLANOVO_MENU_1900200599],
   alimentacao: false,
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Levantamento Estoque Escola',
  path: '/merenda/merlevantamentoestoqueescola/cadastro/:id?',
  parent: 'merlevantamentoestoqueescola',
  name: 'merlevantamentoestoqueescola_create',
  component: () => import('@/views/merenda/merlevantamentoestoqueescola/IncluirEditar.vue'),
  meta: {
   permissions: [eTipoPermissao.LEVANTAMENTODEESTOQUEESCOLANOVO_MENU_1900200599],
   alimentacao: false,
  },
  goesToMenu: true,
 },
 {
  description: 'Itens do Levantamento Estoque Escola',
  path: '/merenda/merlevantamentoestoqueescola/:id/itens',
  parent: 'merlevantamentoestoqueescola',
  name: 'merlevantamentoestoqueescola_itens',
  component: () => import('@/views/merenda/merlevantamentoestoqueescola/Itens.vue'),
  meta: {
   permissions: [eTipoPermissao.LEVANTAMENTODEESTOQUEESCOLANOVO_MENU_1900200599],
   alimentacao: false,
  },
  goesToMenu: false,
 },
 {
  description: 'Levantamento Alimentacao',
  path: '/merenda/merlevantamentoalimentacao',
  name: 'merlevantamentoalimentacao',
  component: () => import('@/views/merenda/merlevantamentoestoqueescola/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.LEVANTAMENTODEESTOQUEALIMENTACAONOVO_MENU_1000300599],
   alimentacao: true,
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Levantamento Alimentacao',
  path: '/merenda/merlevantamentoalimentacao/cadastro/:id?',
  parent: 'merlevantamentoalimentacao',
  name: 'merlevantamentoalimentacao_create',
  component: () => import('@/views/merenda/merlevantamentoestoqueescola/IncluirEditar.vue'),
  meta: {
   permissions: [eTipoPermissao.LEVANTAMENTODEESTOQUEALIMENTACAONOVO_MENU_1000300599],
   alimentacao: true,
  },
  goesToMenu: true,
 },
 {
  description: 'Itens do Levantamento Alimentacao',
  path: '/merenda/merlevantamentoalimentacao/:id/itens',
  parent: 'merlevantamentoalimentacao',
  name: 'merlevantamentoalimentacao_itens',
  component: () => import('@/views/merenda/merlevantamentoestoqueescola/Itens.vue'),
  meta: {
   permissions: [eTipoPermissao.LEVANTAMENTODEESTOQUEALIMENTACAONOVO_MENU_1000300599],
   alimentacao: true,
  },
  goesToMenu: false,
 },
]
